module.exports = __webpack_public_path__ + "static/media/pfg-logo-white.5e86781a.png";